'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numberFormatMixin = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _defaultsDeep = require('lodash/defaultsDeep');

var _defaultsDeep2 = _interopRequireDefault(_defaultsDeep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ## Number formatting mixin
 *
 * This mixin allows for easy, centralized formatting of numbers to a given format.
 * The format can be specified using the $numberFormat data variable on a app/component basis.
 *
 * Additionally the second attribute can be passed to override the default settings for a specific value.
 *
 * Settings must be an object of the following form:
 *
 * {
 *      decimals: 2,
 *      thousandSeparator: '.',
 *      decimalPoint: ','
 * }
 *
 * @example
 * // Usage in a template: Round to default number of places
 * {{ $number(myValue) }}
 *
 * // Usage in template: Round to given number of places
 * {{ $number(myValue, { decimals: 3 }) }}
 *
 * // Usage in JS
 * this.$number(myValue)
 */
var numberFormatMixin = exports.numberFormatMixin = {

    methods: {
        $number: function $number(number) {
            var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            // Apply component defaults from this.$numberFormat if available
            if (this.$numberFormat) {
                settings = (0, _defaultsDeep2.default)(settings, this.$numberFormat);
            }

            // Apply defaults.
            settings = (0, _defaultsDeep2.default)(settings, {
                decimals: 2,
                thousandSeparator: '.',
                decimalPoint: ','
            });

            // Round
            var multiplier = Math.pow(10, settings.decimals);
            number = Math.round(number * multiplier) / multiplier;

            var _String$split = String(number).split('.'),
                _String$split2 = (0, _slicedToArray3.default)(_String$split, 2),
                integers = _String$split2[0],
                decimals = _String$split2[1];

            // Add thousand separator


            integers = integers.replace(/(.)(?=(\d{3})+$)/g, '$1' + settings.thousandSeparator);

            // Add decimal point, if necessarry
            if (decimals) {
                return [integers, decimals].join(settings.decimalPoint);
            }

            return integers;
        }
    }
};